module.exports = __webpack_public_path__ + "static/img/loginBack.b6ebdc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loginBack.jpg
// module id = JFog
// module chunks = 3